<template>
  <div class="region">
    <div class="content" v-html="str"></div>
  </div>
</template>

<script>
export default {
  name: "ReadDisclaimer",
  data() {
    return {
      str: `<div style="font-size:0.16rem;">
	<h2 style="text-align:center;">
		<strong>[</strong><strong>All-In&nbsp;One&nbsp;Platform]</strong> 
	</h2>
	<h2 style="text-align:center;">
		<strong>会务管理平台使用声明与确认函</strong> 
	</h2>
	<p>
		<strong><span><span style="color:#222222;font-family:Consolas, &quot;background-color:#FFFFFF;">一、</span>您的权限<span></span></span></strong> 
	</p>
	<p>
		本平台（线上会议平台功能除外）仅对公司雇佣的在职员工开放。
	</p>
	<p>
		请确保您所申请使用会务服务所提供的信息和资料的真实性、准确性、及时性、有效性及完整性，一旦正式提交，您将作为会议负责人承担相应的管理职责，且应完全遵守公司相关的政策、流程及其他合规要求。
	</p>
	<p>
		本平台中所含的任何信息仅限内部被授权员工查询，公司不允许将任何本平台中的内容对外传播。
	</p>
	<p>
		如您一旦解除或终止与公司的劳动关系，或其他特定情况下，公司会视需要暂停或终止您登陆本平台的权限。在此情况下，公司并不需要您的事先同意或对您进行任何通知
	</p>
	<p>
		<strong><span style="color:#222222;font-family:Consolas, &quot;background-color:#FFFFFF;">二、</span>本平台的使用</strong> 
	</p>
	<p>
		除非本条款另有明确说明，您使用本平台并不意味着被授权使用本平台中的任何信息或资料。仅在符合公司相关政策、流程要求，且为了满足申请公司业务所需的会务服务的目的之前提下，您可上传和提供所需的信息。除此之外，您不得以任何方式或理由对本平台中的任何信息或资料的任何部分进行下载、使用、复制、拍照、摄像、截屏、修改、抄录、传播或用于其他目的。&nbsp;
	</p>
	<p>
		请注意本平台中的内容可能含有公司的保密信息。根据公司已公示并生效的《员工手册》等规章制度，以及您入职时与公司签署的《劳动合同》和《保密协议》（如有），您应保护本平台中的内容并不得以任何方式向第三方泄露。
	</p>
	<p>
		如有违反，公司有权暂停或终止您使用本平台的权限并根据《员工手册》等规章制度对您进行相应处罚。如您严重违反上述要求或以其他方式不当使用或披露本平台中的任何内容，除上述处罚以外，公司保留进一步向您追究法律责任的权利。
	</p>
	<p>
		<strong><span style="color:#222222;font-family:Consolas, &quot;background-color:#FFFFFF;">三、</span>本平台对个人信息的收集、处理与使用</strong> 
	</p>
	<p>
		公司在您使用本平台的过程中将收集您已同意并向我们提供的个人信息，包括但不限于姓名、联系方式等申请会务服务所需的必要信息。该等个人信息的处理与使用将按遵循本条款与公司现行有效的《员工手册》。公司将按照法律法规的规定采取必要的技术手段保护您的个人信息的安全。
	</p>
	<p>
		您充分知晓、理解并明确同意公司可能将该等个人信息转移至其他国家或地区，或者在这些国家或地区对个人信息进行处理
	</p>
	<p>
		如果你所提供的信息包含任何第三方（包括但不限于医疗卫生专业人士）的个人信息，请务必确保取得其明确的知情同意。
	</p>
	<p>
		为更好地提供会务服务和/或满足公司所需的其他业务或合规审计需求，公司可能将您的信息提供给我们的代理、供应商、分包商或合作伙伴以供其代表我们履行本平台的服务或履行公司要求的其他服务。但上述人员不得将该信息用于其他方面也不能与不共同提供服务的任何第三方共享或重新出售这种数据。
	</p>
	<p>
		<strong><span style="color:#222222;font-family:Consolas, &quot;background-color:#FFFFFF;">四、</span>联系方式</strong> 
	</p>
	<p>
		如您对本平台的使用有任何疑义或改进意见，欢迎您通过在A1会务管理平台的意见栏中进行反馈。
	</p>
	<p>
		<span style="color:#FF0000;">*活动和会议负责人应严格遵守公司相关的活动和会议政策的要求， 在使用A1平台申请活动和会议前， 应根据政策规定，基于其申请权限申请所需的活动和会议，并严格予以执行，包括但不限于在完成后，上传真实、完整、准确的支持性文件。</span> 
	</p>
	
</div>`,
    };
  },
};
</script>
<style scoped>
.region {
  margin: 0.2rem;
  vertical-align: middle;
  text-align: left;
}
</style>
